export default function Spinner() {
  return (
    <div className='flex items-center justify-center gap-1 h-[90%]'>
    <span className="animate-pulse">
      <div className="w-8 h-8 bg-violet-500 rounded-full"></div>
    </span>    
    <span className="animate-pulse animate-delay-1">
      <div className="w-8 h-8 bg-violet-500 rounded-full"></div>
    </span>    
    <span className="animate-pulse animate-delay-2">
      <div className="w-8 h-8 bg-violet-500 rounded-full"></div>
    </span>
    </div>
  )
}